import { createReducer } from 'redux-create-reducer'
import type { Playlist } from 'types/playlist'
import {
  PLAYLISTS_LOAD_NEXT,
  PLAYLISTS_LOAD_NEXT_FAIL,
  PLAYLISTS_LOAD_NEXT_SUCCESS,
  PLAYLISTS_SEARCH,
  PLAYLISTS_SEARCH_FAIL,
  PLAYLISTS_SEARCH_SUCCESS,
} from '@disco/constants/ActionTypes'
export type PlaylistTypeState = {
  error: Error | null | undefined
  loading: boolean
  loaded: boolean
  next: string | null | undefined
  items: Playlist[]
}
export type State = {
  albums: PlaylistTypeState
  playlists: PlaylistTypeState
}
const initialPlaylistTypeState = {
  error: null,
  loading: false,
  loaded: false,
  next: null,
  items: [],
}
const initialState: State = {
  albums: initialPlaylistTypeState,
  playlists: initialPlaylistTypeState,
}
export const searchReducer = createReducer<State, any>(initialState, {
  [PLAYLISTS_LOAD_NEXT](state, { key }) {
    return { ...state, [key]: { ...state[key], error: null, loading: true } }
  },

  [PLAYLISTS_LOAD_NEXT_SUCCESS](state, { key, response }) {
    return {
      ...state,
      [key]: {
        error: null,
        loaded: true,
        loading: false,
        next: response.next,
        items: [...state[key].items, ...response.results],
      },
    }
  },

  [PLAYLISTS_LOAD_NEXT_FAIL](state, { key, error }) {
    return { ...state, [key]: { ...state[key], error, loading: false } }
  },

  [PLAYLISTS_SEARCH](state, { key }) {
    return { ...state, [key]: { ...state[key], error: null, loading: true } }
  },

  [PLAYLISTS_SEARCH_SUCCESS](state, { key, response }) {
    return {
      ...state,
      [key]: {
        error: null,
        loaded: true,
        loading: false,
        next: response.next,
        items: response.results,
      },
    }
  },

  [PLAYLISTS_SEARCH_FAIL](state, { key, error }) {
    return { ...state, [key]: { ...state[key], error, loading: false } }
  },
})
